import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { waLink, statusWaMessage } from "@/lib/whatsapp";

export default function WhatsAppFloat() {
  const [wa, setWa] = useState("");

  useEffect(() => {
    api.get("/config").then((r) => setWa(r.data.whatsapp || "")).catch(() => {});
  }, []);

  if (!wa) return null;

  return (
    <a
      href={waLink(wa, statusWaMessage(""))}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Cek status pesanan via WhatsApp"
      className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 pl-3 pr-4 py-3 rounded-full bg-[#25D366] hover:bg-[#1EBE5A] text-white text-xs font-bold shadow-lg transition-colors"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline">Cek Status via WhatsApp</span>
    </a>
  );
}
